import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from '../types';
import { MISSING_CUSTOMER } from '@open-tender/types';
import { selectToken } from './account';
import { showNotification } from '../notifications';
const initialState = {
    entities: [],
    data: null,
    error: null,
    loading: 'idle'
};
export var PointsShopActionType;
(function (PointsShopActionType) {
    PointsShopActionType["FetchPointsShop"] = "pointsShop/fetchPointsShop";
    PointsShopActionType["ExchangePointsShopReward"] = "pointsShop/exchangePointsShopReward";
})(PointsShopActionType || (PointsShopActionType = {}));
export const fetchPointsShop = createAsyncThunk(PointsShopActionType.FetchPointsShop, (_, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { api } = getState().config;
        if (!api)
            return;
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        return yield api.getPointsShop(token);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const exchangePointsShopReward = createAsyncThunk(PointsShopActionType.ExchangePointsShopReward, (rewardId, { getState, dispatch, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { api } = getState().config;
        if (!api)
            return { data: null, entities: [] };
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        yield api.postPointsShopReward(token, rewardId);
        dispatch(showNotification('Reward successfully redeemed!'));
        return yield api.getPointsShop(token);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const pointsShopSlice = createSlice({
    name: ReducerType.PointsShop,
    initialState,
    reducers: {
        resetPointsShop: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(fetchPointsShop.fulfilled, (state, action) => {
            state.entities = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchPointsShop.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchPointsShop.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        })
            .addCase(exchangePointsShopReward.fulfilled, (state, action) => {
            state.entities = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(exchangePointsShopReward.pending, state => {
            state.loading = 'pending';
        })
            .addCase(exchangePointsShopReward.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetPointsShop: resetPointsShop } = pointsShopSlice.actions;
export const selectPointsShop = (state) => state.customer.pointsShop;
export const pointsShopReducer = pointsShopSlice.reducer;
